module.exports = __webpack_public_path__ + "img/16.b11a1ff6.svg";